import styles from "./Admins.module.scss";
import { useEffect, useState } from "react";
import StaffItem from "../StaffItem/StaffItem";
import { useLocation, useNavigate } from "react-router-dom";
import StaffEmpty from "../StaffEmpty/StaffEmpty";
import { useGetAllAdminsQuery } from "../../../api/queries";

const Admins = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [searchValue, setSearchValue] = useState<string | null>(null);
  const { data: adminList = [], refetch } = useGetAllAdminsQuery(searchValue);

  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location.search);
      const shouldUpdate = searchParams.get("shouldUpdate");
      if (searchParams.get("searchValue") !== searchValue) {
        setSearchValue(searchParams.get("searchValue"));
      }
      if (shouldUpdate) {
        refetch();
      }
      navigate("/staff/admins");
    }
  }, [location]);

  if (!adminList.length) {
    return <StaffEmpty activeTab={"admin"} />;
  }

  return (
    <div className={styles.wrapper}>
      {adminList.length &&
        adminList.map((el) => {
          return <StaffItem key={el.id} data={el} activeTab={"admin"} />;
        })}
    </div>
  );
};

export default Admins;
